import { LoginStep } from '../../../entities/Login';

export default class LoginModel {
  static readonly steps: LoginStep[] = [LoginStep.CPF, LoginStep.CODE_METHOD, LoginStep.CODE, LoginStep.SUCCESS];

  static getStepIndex(step: LoginStep): number {
    return LoginModel.steps.indexOf(step);
  }

  static nextStep(step: LoginStep): LoginStep {
    const index = LoginModel.steps.indexOf(step);
    return LoginModel.steps[Math.min(index + 1, LoginModel.steps.length - 1)];
  }
}
